import type { Locale } from 'antd/es/locale';
import enUS from 'antd/es/locale/en_US';
import plPL from 'antd/es/locale/pl_PL';
import trTR from 'antd/es/locale/tr_TR';
import frFR from 'antd/es/locale/fr_FR';
import esES from 'antd/es/locale/es_ES';
import ukUA from 'antd/es/locale/uk_UA';
import deDE from 'antd/es/locale/de_DE';
import huHU from 'antd/es/locale/hu_HU';

export type LanguageKey = 'en' | 'pl' | 'tr' | 'fr' | 'es' | 'uk' | 'de' | 'hu';

export interface Language {
  key: LanguageKey;
  label: string;
}

export const Languages: Language[] = [
  { key: 'en', label: 'English' },
  { key: 'pl', label: 'Polski' },
  { key: 'tr', label: 'Türkçe' },
  { key: 'fr', label: 'Français' },
  { key: 'es', label: 'Español' },
  { key: 'uk', label: 'Українська' },
  { key: 'de', label: 'Deutsch' },
  { key: 'hu', label: 'Magyar' },
];

export const DefaultLanguage: LanguageKey = 'en';

export const AntdLocales: Record<LanguageKey, Locale> = {
  en: enUS,
  pl: plPL,
  tr: trTR,
  fr: frFR,
  es: esES,
  uk: ukUA,
  de: deDE,
  hu: huHU,
};